export const Patterns = {
    EMAILADDRESS: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    PASSWORD: /^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]))(?=.*\d)(?=.*[?#$^+=!*(){}[\]:;<>,.~_\-@%&/\\]).{6,39}/,
    REGISTER_CODE: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i
};
